import { render, staticRenderFns } from "./ProuniAcceptanceForm.vue?vue&type=template&id=542a1196&scoped=true&"
import script from "./ProuniAcceptanceForm.vue?vue&type=script&lang=ts&"
export * from "./ProuniAcceptanceForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniAcceptanceForm.vue?vue&type=style&index=0&id=542a1196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a1196",
  null
  
)

export default component.exports